import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, catchError, throwError } from 'rxjs';
import { environment } from 'src/environments/environment';
// import { environment } from 'src/environments/environment-dev2';
import { ApiResponse } from '../Model/api-response';
import { summaryListResponse, quoteList } from '../module/shared/models';

let headers1: HttpHeaders = new HttpHeaders();
headers1 = headers1.append('Content-Type', 'application/json');
headers1 = headers1.append('Authorization', 'application/json');

@Injectable({
  providedIn: 'root'
})
export class InsightService {
  insightUrl = `${environment.serviceBaseUrl}`;

  referralUrl = `${environment.serviceBaseUrl}`;
  quotePolicyStatus: string = 'All';
  lastStage: string = '';
  private isRefreshEcoverList = new BehaviorSubject<boolean | false>(false);
  isRefreshEcoverList$ = this.isRefreshEcoverList.asObservable();
  // quoteUrl = 'http://partner1-nlb-dev-37a54b450374a7d6.elb.ap-south-1.amazonaws.com:10012/';
  // masterUrl='http://partner1-nlb-dev-37a54b450374a7d6.elb.ap-south-1.amazonaws.com:10010/';
  // proposalUrl='http://partner1-nlb-dev-37a54b450374a7d6.elb.ap-south-1.amazonaws.com:10013/';
  // policyUrl='http://partner1-nlb-dev-37a54b450374a7d6.elb.ap-south-1.amazonaws.com:10014/';
  // orchestrationUrl='http://partner1-nlb-dev-37a54b450374a7d6.elb.ap-south-1.amazonaws.com:10016/';
  // paymentUrl='http://partner1-nlb-dev-37a54b450374a7d6.elb.ap-south-1.amazonaws.com:10006/';
  // uwworkbenchUrl='http://partner1-nlb-dev-37a54b450374a7d6.elb.ap-south-1.amazonaws.com:10020/';

  quoteUrl = this.insightUrl;
  masterUrl = this.insightUrl;
  proposalUrl = this.insightUrl;
  policyUrl = this.insightUrl;
  orchestrationUrl = this.insightUrl;
  paymentUrl = this.insightUrl;
  uwworkbenchUrl = this.insightUrl;
  constructor(private http: HttpClient) { }

  getCountOfQuote(userID: any, groupType: any): Observable<any> {
    return this.http.get(`${this.quoteUrl}api/lgiindia/partnerportal/quote/motor/v1/dashboardCount/${userID}?groupType=${groupType}`)
    // return this.http.get(`http://localhost:10012/api/lgiindia/partnerportal/quote/motor/v1/dashboardCount/${userID}?groupType=${groupType}`)
  }

  getQcInsightsCountData(groupType: any, userID: any): Observable<any> {
    return this.http.get(`${this.policyUrl}api/lgiindia/partnerportal/policy/motor/v1/qcStatusDashbordCount/${userID}?groupType=${groupType}`)
  }

  getQuoteFilterData(data: any): Observable<any> {
    return this.http.post(`${this.quoteUrl}api/lgiindia/partnerportal/quote/motor/v1/getQuoteSummaryList/filterSearch`, data)
  }

  getCountOfEndorsement(userID: any): Observable<any> {
    return this.http.get(`${this.policyUrl}api/lgiindia/partnerportal/policy/v2/count/${userID}`)
  }

  getCountOfProposal(groupType: any, userID: any): Observable<any> {
    return this.http.get(`${this.proposalUrl}api/lgiindia/partnerportal/proposal/motor/v1/dashboardCount/${userID}?groupType=${groupType}`)
  }

  getQuoteDetails(id: any): Observable<any> {
    return this.http.get(`${this.quoteUrl}api/lgiindia/partnerportal/quote/motor/v1/getQuoteDetails/${id}`)
  }

  getQuoteFilterSearchData(data: any): Observable<ApiResponse<summaryListResponse>> {
    return this.http.post<ApiResponse<summaryListResponse>>(`${this.quoteUrl}api/lgiindia/partnerportal/quote/motor/v1/summaryList`, data)
  }

  getProposalFilterSearchData(data: any): Observable<any> {
    return this.http.post(`${this.proposalUrl}api/lgiindia/partnerportal/proposal/motor/v1/summarylist/filtersearch`, data)
  }

  getInspectinCount(groupType: any, imdCode: string): Observable<any> {
    return this.http.get(`${this.proposalUrl}api/lgiindia/partnerportal/proposal/motor/v1/inspection/dashboardcount/${imdCode}?groupType=${groupType}`);
  }

  getReferralCount(groupType: any, imdCode: string): Observable<any> {
    return this.http.get(`${this.quoteUrl}api/lgiindia/partnerportal/quote/motor/v1/referralCount/${imdCode}?groupType=${groupType}`);
  }

  // NSTP count for Fire's FIRE_LOCAL_UW/FIRE_REGIONAL_UW/FIRE_HO_UW/FIRE_ZONAL_UW group types
  getFireReferralCount(groupType: any, imdCode: string): Observable<any> {
    return this.http.get(`${this.quoteUrl}api/lgiindia/partnerportal/quote/fire/v1/referralCount/${imdCode}?groupType=${groupType}`);
    // return this.http.get(`http://localhost:10068/api/lgiindia/partnerportal/quote/fire/v1/referralCount/${imdCode}?groupType=${groupType}`);
  }

  getNSTPFilterSearchData(data: any): Observable<any> {
    return this.http.post(`${this.quoteUrl}api/lgiindia/partnerportal/quote/motor/v1/filterReferralBySearchCriteria`, data)
    // return this.http.post(`http://localhost:10068/api/lgiindia/partnerportal/quote/motor/v1/filterReferralBySearchCriteria`, data)
  }

  // NSTP list search for Fire's FIRE_LOCAL_UW/FIRE_REGIONAL_UW/FIRE_HO_UW/FIRE_ZONAL_UW group types
  getFireNSTPFilterSearchData(data: any): Observable<any> {
    return this.http.post(`${this.quoteUrl}api/lgiindia/partnerportal/quote/fire/v1/filterFireReferralBySearchCriteria`, data)
    // return this.http.post(`http://localhost:10068/api/lgiindia/partnerportal/quote/fire/v1/filterFireReferralBySearchCriteria`, data)
  }



  getEcoverData(): Observable<any> {
    return this.http.get(`${this.masterUrl}api/lgiindia/partnerportal/master/v1/commonMasters/ECoverNoteSearch`);
  }

  getEcoverNote(data: any): Observable<any> {
    return this.http.post(`${this.policyUrl}api/lgiindia/partnerportal/policy/motor/v1/eCovernote/filter`, data)
  }

  getViewEcoverNote(policyNo, userName?: any, lobName?: string): Observable<any> {
    const isCommercial = lobName?.trim().toLowerCase() === 'commercial';
    const endpoint = isCommercial
      ? `api/lgiindia/partnerportal/policy/fire/v1/fireQcDetails/${policyNo}`
      : `api/lgiindia/partnerportal/policy/motor/v1/qcDetails/${policyNo}`;
    return this.http.get(`${this.policyUrl}${endpoint}?userId=${userName}`);
  }

  getEcoverRejection(): Observable<any> {
    return this.http.get(`${this.masterUrl}api/lgiindia/partnerportal/master/v1/commonMasters/QcRejectionReason`);
  }

  updatePolicy(data: any): Observable<any> {
    // return this.http.post(`http://localhost:10225/api/lgiindia/partnerportal/policy/motor/v1/updatePolicyStage`, data)
    return this.http.post(`${this.policyUrl}api/lgiindia/partnerportal/policy/motor/v1/updatePolicyStage`, data)
  }

  acceptPolicy(data: any): Observable<any> {
    return this.http.post(`${this.policyUrl}api/lgiindia/partnerportal/policy/motor/v1/gcsyncpolicydata`, data).pipe(
      catchError(this.handleError.bind(this))
    )
  }

  acceptFirePolicy(data: any): Observable<any> {
    return this.http.post(`${this.policyUrl}api/lgiindia/partnerportal/policy/fire/v1/gcsyncpolicydata`, data).pipe(
      catchError(this.handleError.bind(this))
    )
  }

  documentDataPolicy(policyNo, isDocDiscrepancy): Observable<any> {
    const queryParams = {
      isDocDiscrepancy: isDocDiscrepancy
    }
    return this.http.get(this.policyUrl + 'api/lgiindia/partnerportal/policy/motor/v1/documentDataPolicy/' + policyNo, { params: queryParams })
  }



  updateDiscrepantDocumentStatus(payload: any): Observable<any> {
    return this.http.post(this.policyUrl + 'api/lgiindia/partnerportal/policy/motor/v1/updatedStatus', payload)
  }

  commonreportdownload(payload: any): Observable<any> {
    return this.http.post(this.orchestrationUrl + 'api/lgiindia/partnerportal/orchestration/proposal/v1/commonreportdownload', payload, { responseType: 'json' })
  }

  commoncancelecovernotereportdownload(quoteNumber: any): Observable<any> {
    // return this.http.post(this.orchestrationUrl + 'api/document/download/pdf/ECNCancellation/', quoteNumber)
    return this.http.get(this.orchestrationUrl + 'api/document/download/pdf/ECNCancellation/' + quoteNumber, { responseType: 'blob' })
  }

  getDownloadFilterSearchData(payload: any): Observable<any> {
    return this.http.post(this.policyUrl + `api/lgiindia/partnerportal/policy/motor/v1/summarylist/filtersearch`, payload)
  }

  getDownloadGCPolicy(payload: any): Observable<any> {
    return this.http.post(this.orchestrationUrl + `api/lgiindia/partnerportal/orchestration/integration/v1/downloadreport`, payload, { responseType: 'blob' })
  }

  getVehicleDetails(quoatNumber?: any): Observable<any> {
    return this.http.get(this.quoteUrl + `api/lgiindia/partnerportal/quote/motor/v1/getVehicleDetails/` + quoatNumber);
    //return this.http.get(this.proposalUrl + 'api/lgiindia/partnerportal/quote/motor/v1/getVehicleDetails/Q311224315111140000019');
    // return this.http.get('https://partnerfirstapi-uat.libertyinsurance.in/api/lgiindia/partnerportal/quote/motor/v1/getVehicleDetails/Q311224315111140000019`);
  }

  calculatePremium(payload): Observable<any> {
    //console.log('abcd');

    //http://localhost:10416/api/lgiindia/partnerportal/orchestration/integration/v1/calculateCancellationPremium
    // return this.http.post(`${this.proposalUrl}api/lgiindia/partnerportal/orchestration/integration/v1/calculateCancellationPremium`, payload)
    return this.http.post('https://partnerfirstapi-uat.libertyinsurance.in/api/lgiindia/partnerportal/orchestration/integration/v1/calculateCancellationPremium', payload)
  }


  // cancellationInit(): Observable<any> {
  //   return this.http.get(this.masterUrl + 'api/lgiindia/partnerportal/master/v1/commonMasters/CancellationInitiatedBy');
  // } // Done

  // cancellationPayeeType(): Observable<any> {
  //   return this.http.get(this.masterUrl + 'api/lgiindia/partnerportal/master/v1/commonMasters/PayeeType')
  // } // Done

  // cancellationInsurance(): Observable<any> {
  //   return this.http.get(this.masterUrl + 'api/lgiindia/partnerportal/master/v1/commonMasters/RetainCancellationPremium');
  // } //Done

  // cancellationReason(): Observable<any> {
  //   return this.http.get(this.masterUrl + 'api/lgiindia/partnerportal/master/v1/commonMasters/CancellationReason');
  // } //Done

  // cancellationGogreen(): Observable<any> {
  //   return this.http.get(this.masterUrl + 'api/lgiindia/partnerportal/master/v1/commonMasters/GoGreen');
  // } // Done

  // cancellationCoverType(): Observable<any> {
  //   return this.http.get(this.masterUrl + 'api/lgiindia/partnerportal/master/v1/commonMasters/CancellationCoverType');
  // }

  getEfileDownloadPolicy(docEfileNumber: any): Observable<any> {
    return this.http.get(this.uwworkbenchUrl + `api/lgiindia/partnerportal/uwworkbench/referral/download/claimDoc/${docEfileNumber}`, { responseType: 'blob' })
  }

  editPaymentData(batchNumber: any): Observable<any> {
    return this.http.get(`${this.paymentUrl}api/lgiindia/partnerportal/payment/v1/editPaymentData/${batchNumber}`)
  }

  savePaymentDetails(payload): Observable<any> {
    return this.http.post(`${this.paymentUrl}api/lgiindia/partnerportal/payment/v1/editPaymentDetails`, payload)
  }

  getLastStage(): string {
    return this.lastStage;
  }

  setLastStage(stage: string): void {
    this.lastStage = stage;
  }

  private handleError(error: HttpErrorResponse) {
    let errorMessage = 'Unknown error!';
    if (error.status === 0 || error.status === 504 || error.error?.message || error.message || error) {
      //console.log('gate way time out');
      errorMessage = "Policy approved, Please refesh page after 2 min";
    }
    this.errorSubject.next(errorMessage);
    return throwError(errorMessage);
  }

  private errorSubject = new BehaviorSubject<string | null>(null);
  error$ = this.errorSubject.asObservable();

  getCollectionData(data: any): Observable<any> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    return this.http.post(`${this.masterUrl}api/lgiindia/partnerportal/proposal/motor/v1/collectionMapData`, data, { headers });
  }

  getproductOptions(lobId: number): Observable<any> {
    return this.http.get<any[]>(`${this.masterUrl}api/lgiindia/partnerportal/master/v1/vehicleClass/productType/${lobId}`);
  }

  getLobOption(): Observable<any> {
    return this.http.get<any[]>(`${this.masterUrl}api/lgiindia/partnerportal/master/v1/lobList`);
  }

  getBrnachOptions(): Observable<any> {
    return this.http.get<any[]>(`${this.masterUrl}api/lgiindia/partnerportal/master/v1/getBranchCodeDetails`);
  }

  etSearchCriteriaFilterData(groupType: any, data: any, imdCode: string): Observable<any> {
    return this.http.get(`${this.quoteUrl}api/lgiindia/partnerportal/orchestration/proposal/v1/getcommondetail/${data}/${imdCode}?groupType=${groupType}`)
  }
  cancelPolicy(payload: any): Observable<any> {
    return this.http.post(`${this.quoteUrl}api/lgiindia/partnerportal/policy/motor/v1/eCoverNotecancel`, payload)
    // return this.http.post(`http://intl-in-spp-nlb-staging-ccb638c9d699516c.elb.ap-south-1.amazonaws.com:10014/api/lgiindia/partnerportal/policy/motor/v1/eCoverNotecancel
    //  `, payload)
  }

  addCollection(data: any): Observable<any> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    return this.http.post(`${this.masterUrl}api/lgiindia/partnerportal/integration/v1/lovInfo`, data, { headers });
  }

  getQcPaymentData(data: any): Observable<any> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    return this.http.post(`${this.masterUrl}api/lgiindia/partnerportal/payment/v1/filter/getQcPaymentData`, data, { headers });
  }

  offlineAdvancePayment(data: any): Observable<any> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    return this.http.post(`${this.masterUrl}api/lgiindia/partnerportal/payment/v1/action/offlineAdvancePayment`, data, { headers });
  }

  getImdCollectionData(data: any): Observable<any> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    return this.http.post(`${this.masterUrl}api/lgiindia/partnerportal/payment/v1/getCollectionPaymentDetails`, data, { headers })
  }

  updateCollectionMappingData(data: any): Observable<any> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    return this.http.post(`${this.masterUrl}api/lgiindia/partnerportal/policy/motor/v1/updateCollectionMapData`, data, { headers });
  }

  saveImdCollectionData(data: any): Observable<any> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    return this.http.post(`${this.masterUrl}api/lgiindia/partnerportal/orchestration/proposal/v1/savePaymentDetails`, data, { headers })
  }

  refreshEcoverList(isRefresh: boolean): void {
    this.isRefreshEcoverList.next(isRefresh);
  }

  saveCancelMoterDetail(data: any): Observable<any> {
    return this.http.post(this.proposalUrl + 'api/lgiindia/partnerportal/policy/v2/saveMotorCancellationDetails', data);
    // return this.http.post('http://localhost:10087/api/lgiindia/partnerportal/policy/v2/saveMotorCancellationDetails', data)
  }

  getCancellationAllData(userID: string, status: string, pageNumber: any): Observable<any> {
    return this.http.get(`${this.proposalUrl}api/lgiindia/partnerportal/policy/v2/cancellationUserBucket/${userID}/${status}/${pageNumber}`)
    // return this.http.get(`http://localhost:10087/api/lgiindia/partnerportal/policy/v2/cancellationUserBucket/${userID}/${status}/${pageNumber}`)

  }

  filterCancellationSearch(data: any): Observable<any> {
    return this.http.post(`${this.proposalUrl}api/lgiindia/partnerportal/policy/v2/getCancellationList/filterSearch`, data)
    // return this.http.post(`http://localhost:10087/api/lgiindia/partnerportal/policy/v2/getCancellationList/filterSearch`, data)
  }

  getCancellationCustomerData(policyNumber: any): Observable<any> {
    return this.http.get(`${this.policyUrl}api/lgiindia/partnerportal/policy/v2/getCancellationDetails/${policyNumber}`)
    // http://partner1-nlb-dev-37a54b450374a7d6.elb.ap-south-1.amazonaws.com:10014/api/lgiindia/partnerportal/policy/v2/getCancellationDetails/201110000025780059600000
    // return this.http.get(`${this.policyUrl}api/lgiindia/partnerportal/policy/v2/getCancellationDetails/${policyNumber}`)
  }

  getCancellationDocumentData(cancellationRequestNumber: any): Observable<any> {
    return this.http.get(`${this.policyUrl}api/lgiindia/partnerportal/policy/v2/documentData/${cancellationRequestNumber}`)
  }

  ValidateCancellationOtp(data: any): Observable<any> {
    // return this.http.post(`http://localhost:10081/api/lgiindia/partnerportal/proposal/motor/v1/validateOtp`, data)
    return this.http.post(this.proposalUrl + 'api/lgiindia/partnerportal/proposal/motor/v1/validateOtp', data)
      .pipe(
        catchError(this.handleError.bind(this))
      )
  }

  getCancellationData(cancellationNumber: any): Observable<any> {
    return this.http.get(`${this.policyUrl}api/lgiindia/partnerportal/policy/v2/getCancellationDetails/${cancellationNumber}`)
  }
  createCancellationPremium(data: any): Observable<any> {
    return this.http.post(`${this.orchestrationUrl}api/lgiindia/partnerportal/orchestration/integration/v1/calculateCancellationPremium`, data)
      .pipe(
        catchError(this.handleError.bind(this))
      )

  }

  approveCancellationPremium(data: any): Observable<any> {
    return this.http.post(`${this.orchestrationUrl}api/lgiindia/partnerportal/orchestration/integration/v1/createCancellationEndorsement`, data)
      .pipe(
        catchError(this.handleError.bind(this))
      )

  }

  rejectionCancellation(data: any): Observable<any> {
    return this.http.post(`${this.policyUrl}api/lgiindia/partnerportal/policy/v2/rejectCancellation`, data)
      .pipe(
        catchError(this.handleError.bind(this))
      )
  }

  updatedCancellationStatus(data: any): Observable<any> {
    return this.http.post(`${this.policyUrl}api/lgiindia/partnerportal/policy/v2/updatedCancellationStatus`, data)
      .pipe(
        catchError(this.handleError.bind(this))
      )
  }

  getRenewalNoticeType(): Observable<any> {
    return this.http.get(`${this.masterUrl}api/lgiindia/partnerportal/master/v1/commonMasters/RenewalNoticeType`)
  }
  getRenewalNoticeGenerateFor(): Observable<any> {
    return this.http.get(`${this.masterUrl}api/lgiindia/partnerportal/master/v1/commonMasters/RenewalNoticeGenerateFor`)
  }
  renewalNoticeFilterSearch(data: any): Observable<any> {
    return this.http.post(`${this.policyUrl}api/lgiindia/partnerportal/policy/motor/v1/policyrenewal`, data)
      .pipe(
        catchError(this.handleError.bind(this))
      )
  }
  getRenewalProductName(): Observable<any> {
    return this.http.get(`${this.masterUrl}api/lgiindia/partnerportal/master/v1/renewalNoticeProductList`)
  }

  renewalNoticeDownloadPdf(data: any): Observable<any> {
    return this.http.post(`${this.masterUrl}api/lgiindia/partnerportal/orchestration/policy/v1/renewalNoticePdfDownload`, data)
      .pipe(
        catchError(this.handleError.bind(this))
      )
  }
  amlZigramStatusCheck(proposalNumber) {
    return this.http.get(`${this.proposalUrl}api/lgiindia/partnerportal/proposal/motor/v1/amlZigramStatusCheck/${proposalNumber}`)
      .pipe(
        catchError(this.handleError.bind(this))
      )

  }
  checkKycStatus(proposalNumber): Observable<any> {
    return this.http.get(`${this.proposalUrl}api/lgiindia/partnerportal/proposal/motor/v1/fetchdetails/${proposalNumber}`)
  }
  resendCKycLink(proposalNumber): Observable<any> {
    return this.http.get(`${this.proposalUrl}api/lgiindia/partnerportal/proposal/motor/v1/resendkyclink/${proposalNumber}`)
  }
}
